import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  output,
  viewChild
} from '@angular/core';

/**
 * Drag/drop + file picker. Emits raw `File[]`; callers filter by type/size/domain rules.
 */
@Component({
  selector: 'app-file-upload-dropzone',
  imports: [CommonModule],
  templateUrl: './file-upload-dropzone.component.html',
  styleUrl: './file-upload-dropzone.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploadDropzoneComponent {
  readonly disabled = input(false);
  /** e.g. `application/pdf` or `image/png,image/jpeg`. */
  readonly accept = input<string>('application/pdf');
  readonly multiple = input(true);
  readonly title = input<string>('Drop files here');
  readonly subtitle = input<string>('or browse to choose files');

  readonly filesPicked = output<File[]>();

  private readonly fileInput = viewChild.required<ElementRef<HTMLInputElement>>('fileInput');

  onFileChange(event: Event): void {
    if (this.disabled()) {
      return;
    }
    const inputEl = event.target as HTMLInputElement;
    const list = inputEl.files ? Array.from(inputEl.files) : [];
    inputEl.value = '';
    if (list.length) {
      this.filesPicked.emit(list);
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    if (this.disabled()) {
      return;
    }
    const dt = event.dataTransfer;
    const list = dt?.files?.length ? Array.from(dt.files) : [];
    if (list.length) {
      this.filesPicked.emit(list);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  openPicker(): void {
    if (this.disabled()) {
      return;
    }
    this.fileInput().nativeElement.click();
  }
}
